export const sendCustomGAEvent = (eventType: string, eventData: object) => {
  if (typeof window !== 'undefined' && window['gtag'])
    window['gtag']('event', eventType, { ...eventData })
}
